// Shared derivations for the Elvis conversations page. The insight charts and
// the drill-down modal count the same way, so a bar's value always matches the
// number of rows behind it.

// Words carrying no review value - stripped before keyword counting.
export const STOP_WORDS = new Set([
    'the', 'and', 'for', 'are', 'but', 'not', 'you', 'your', 'yours', 'with', 'that', 'this', 'these',
    'those', 'have', 'has', 'had', 'was', 'were', 'from', 'what', 'when', 'where', 'which', 'who',
    'whom', 'why', 'how', 'can', 'cant', 'could', 'would', 'should', 'will', 'shall', 'does', 'did',
    'doing', 'done', 'been', 'being', 'into', 'onto', 'over', 'under', 'than', 'then', 'them', 'they',
    'their', 'there', 'here', 'about', 'after', 'before', 'between', 'because', 'also', 'any', 'all',
    'our', 'ours', 'out', 'get', 'got', 'its', 'please', 'need', 'needs', 'know', 'tell', 'show',
    'give', 'want', 'make', 'made', 'just', 'like', 'some', 'more', 'most', 'much', 'many', 'very',
    'one', 'two', 'new', 'use', 'used', 'using', 'see', 'look', 'find', 'help', 'thanks', 'thank',
    'hello', 'elvis', 'anyone', 'somebody', 'something', 'anything', 'able', 'let', 'lets', 'now',
    'still', 'only', 'same', 'other', 'each', 'both', 'own', 'off', 'per', 'via', 'yes'
]);

export const RATING_ORDER = ['good', 'bad', 'unrated'];

export const RATING_LABELS = { good: 'Good', bad: 'Bad', unrated: 'Unrated' };

// isPositive comes back as 1/0, but tolerate booleans so the charts, the table
// icons and the drill-down all agree on what counts as rated.
export const ratingOf = row => {
    const value = row?.isPositive;
    if (value === 1 || value === true) return 'good';
    if (value === 0 || value === false) return 'bad';
    return 'unrated';
};

// The distinct review-worthy words in one question.
export const questionTokens = question => {
    const tokens = new Set();
    if (!question) return tokens;
    String(question)
        .toLowerCase()
        .replace(/[^a-z0-9\s'-]/g, ' ')
        .split(/\s+/)
        .forEach(raw => {
            const word = raw.replace(/^[-']+|[-']+$/g, '');
            if (word.length < 3 || STOP_WORDS.has(word) || /^\d+$/.test(word)) return;
            tokens.add(word);
        });
    return tokens;
};

// Counts each keyword once per question, so the answer is
// "how many questions mention this" rather than raw term frequency.
export const countKeywords = rows => {
    const counts = new Map();
    rows.forEach(row => questionTokens(row.question).forEach(word => {
        counts.set(word, (counts.get(word) ?? 0) + 1);
    }));
    return [...counts.entries()].sort(([, a], [, b]) => b - a);
};

// Ranked [name, count] pairs, largest first.
export const rankBy = (rows, pick) => {
    const counts = new Map();
    rows.forEach(row => {
        const key = pick(row);
        counts.set(key, (counts.get(key) ?? 0) + 1);
    });
    return [...counts.entries()].sort(([, a], [, b]) => b - a);
};

export const userOf = row => row.user || 'Unknown';

export const knowledgeOf = row => row.knowledgeName || 'No match';

export const pct = (part, whole) => whole > 0 ? ((part / whole) * 100).toFixed(2) : 0;
